import { useNavigation } from '@react-navigation/native';
import { images } from '_/space-management/assets';
import { Button, Text } from '_/space-management/components';
import { colors } from '_/space-management/constants/theme';
import { useSpaceContext } from '_/space-management/hooks/SpaceContext';
import { getSpaceTypeColor } from '_/space-management/services/models/enums/space-type.enum';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, View } from 'react-native';

import styles from './styles';
import { fontSizes } from '_/config/theme';

interface NoAvailableSlotsProps {
  maxCapacityReached: boolean;
  notAllowed?: boolean;
}

export default function NoAvailableSlots({
  maxCapacityReached,
  notAllowed = false,
}: NoAvailableSlotsProps) {
  const navigation = useNavigation<any>();
  const { spaceType } = useSpaceContext();
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <Text fontSize={fontSizes.md2} style={[styles.text, styles.topText]}>
        {t(
          `workstationScreen.noAvailableSlots.${
            notAllowed
              ? 'notAllowed'
              : maxCapacityReached
              ? 'maxCapacityReached'
              : 'noAvailableSlotsMessage'
          }`
        )}
      </Text>
      <Image source={images.calendarYellow} />
      <Text fontSize={fontSizes.md2} style={[styles.text, styles.bottomText]}>
        {t(
          `workstationScreen.noAvailableSlots.${
            notAllowed ? 'tryAnotherSpace' : 'tryAnotherSchedule'
          }`
        )}
      </Text>
      <Button
        backgroundColor={getSpaceTypeColor(spaceType)}
        textColor={colors.white}
        onPress={() => navigation.goBack()}
      >
        {t('spaceManage.workstationScreen.noAvailableSlots.backToSchedule')}
      </Button>
    </View>
  );
}
